/**
 * AI Companions fallback data — used when the API is not available.
 * Shared across chat screens for consistent companion rendering.
 */

/**
 * Agapella's brand avatar — the approved AI icon shown as the logo on the chat
 * page (header/preview) for the default assistant. Local asset so it's stable
 * regardless of the API-configured avatarUrl.
 */
export const AGAPELLA_AI_ICON = require('../../assets/avatars/agapella_ai_icon.jpg');

export const AI_COMPANIONS_FALLBACK = [
    {
        id: 'sophia',
        name: 'Agapella',
        subtitle: 'AI Companion \u00B7 Inner Growth',
        // Brand glyph (\u2726) fallback wins over a stock-photo default for
        // a fictional persona \u2014 chat renderers paint the solar glyph
        // in place of an Image when avatarUrl is null.
        avatarUrl: null as string | null,
        category: 'PSYCHOLOGY',
        description: 'Your personal guide for self-reflection, emotional wellness, and inner peace.',
        streamUserId: 'ai_sophia' as string | null,
        starterQuestions: [
            'How can I manage anxiety better?',
        ],
        isPsychologist: true,
        isDefault: true,
    },
    {
        id: 'buddha',
        name: 'Buddha',
        subtitle: 'Siddhartha Gautama',
        avatarUrl: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Buddha_in_Sarnath_Museum_%28Dhammajak_Mutra%29.jpg',
        category: 'PHILOSOPHY',
        description: 'Explore the path of mindfulness, compassion, and the nature of suffering.',
        streamUserId: 'ai_buddha' as string | null,
        starterQuestions: [
            'What is the Middle Way?',
            'Teach me about mindfulness',
        ],
        isPsychologist: false,
        isDefault: false,
    },
    {
        id: 'einstein',
        name: 'Einstein',
        subtitle: 'Albert Einstein',
        avatarUrl: 'https://upload.wikimedia.org/wikipedia/commons/d/d3/Albert_Einstein_Head.jpg',
        category: 'SCIENCE',
        description: 'Discuss the mysteries of the universe, creativity, and the power of imagination.',
        streamUserId: 'ai_einstein' as string | null,
        starterQuestions: [
            'What inspired your theory of relativity?',
            'How does imagination relate to science?',
        ],
        isPsychologist: false,
        isDefault: false,
    },
    {
        id: 'aristotle',
        name: 'Aristotle',
        subtitle: 'Greek Philosopher',
        avatarUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/ae/Aristotle_Altemps_Inv8575.jpg',
        category: 'PHILOSOPHY',
        description: 'Dive into logic, ethics, and the pursuit of eudaimonia \u2014 human flourishing.',
        streamUserId: 'ai_aristotle' as string | null,
        starterQuestions: [
            'What is eudaimonia?',
            'How should I live a virtuous life?',
        ],
        isPsychologist: false,
        isDefault: false,
    },
    {
        id: 'plato',
        name: 'Plato',
        subtitle: 'Father of Western Philosophy',
        avatarUrl: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Plato_Silanion_Musei_Capitolini_MC1377.jpg',
        category: 'PHILOSOPHY',
        description: 'Explore the world of ideas, justice, and the nature of reality and truth.',
        streamUserId: 'ai_plato' as string | null,
        starterQuestions: [
            'Tell me about the Allegory of the Cave',
            'What are the Forms?',
        ],
        isPsychologist: false,
        isDefault: false,
    },
];
